import highchartsBasics from '@/language/pt/mixins/highcharts-basics';
import exportModel from '@/language/pt/mixins/export-model';
import pagesModel from '@/language/pt/mixins/pages-model';
import formModel from '@/language/pt/mixins/form-model';

export default {
  highchartsBasics,
  exportModel,
  pagesModel,
  formModel,
};
